var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"headNav"}},_vm._l((_vm.navList),function(item){return _c('p',{directives:[{name:"wave",rawName:"v-wave"}],key:item.value,staticClass:"nav",class:[item.status ? 'navActive' : ''],on:{"click":function($event){return _vm.navActiveChange(item)}}},[_c('i',{class:item.icon}),_vm._v(" "+_vm._s(_vm.$t(item.name))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }